/* eslint import/prefer-default-export: off */

export enum uma {
  LEAD_ID = 'lid',
}
